module.exports = __webpack_public_path__ + "img/methods (2).a8f4ee56.png";